import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { API_URL } from '@simOn/utils/tokens';
import {
  CreateZoneDto,
  UpdateZoneDto,
  UpdateZoneRoomsOrderDto,
  UpdateZonesOrderDto,
  ZoneInterface
} from '@simOn/zone/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZonesApiService {
  private readonly http = inject(HttpClient);
  private readonly _apiUrl = inject(API_URL);

  getZones(): Observable<ZoneInterface[]> {
    return this.http.get<ZoneInterface[]>(`${this._apiUrl}/Zones/GetZones`);
  }

  createZone(zone: CreateZoneDto): Observable<ZoneInterface> {
    return this.http.post<ZoneInterface>(`${this._apiUrl}/Zones/CreateZone`, zone);
  }

  updateZone(zone: UpdateZoneDto): Observable<ZoneInterface> {
    return this.http.put<ZoneInterface>(`${this._apiUrl}/Zones/UpdateZone`, zone);
  }

  deleteZone(id: string): Observable<void> {
    const params = new HttpParams().append('Id', id);
    return this.http.delete<void>(`${this._apiUrl}/Zones/DeleteZone`, { params });
  }

  updateZonesOrder(order: UpdateZonesOrderDto): Observable<void> {
    return this.http.put<void>(`${this._apiUrl}/Zones/UpdateZonesOrder`, order);
  }

  updateZoneRoomsOrder(order: UpdateZoneRoomsOrderDto): Observable<void> {
    return this.http.put<void>(`${this._apiUrl}/Zones/UpdateZoneRoomsOrder`, order);
  }
}
